import { AppStoreButtonView } from "../AppStoreButton";
import { TextView } from "../Text";
import { ButtonView } from "../Button";
import { CounterView } from "../Counter";
import { ImageView } from "../Image";
import { SocialLinksView } from "../SocialLinks";
import { VideoView } from "../Video";
import { FormView } from "../Form";
export const ElementsPreview = {
  Text: TextView,
  Heading: TextView,
  Button: ButtonView,
  Image: ImageView,
  Video: VideoView,
  AppStoreButton: AppStoreButtonView,
  SocialLinks: SocialLinksView,
  Counter: CounterView,
  Form: FormView
};
//# sourceMappingURL=ElementsPreview.js.map